import moment from "moment";
import CashViewGrid from "./CashRegisterGrid";
import {Card} from "antd";
import CashViewFilter from "./CashViewFilter";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import {useUser} from "../../core/context/UserContext";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";

export default function CashViewApp()
{
    const {user} = useUser();

    useEffect(() => {
        document.title = `${t('Cash Register')} - ${AppConfig.getHisTitle()}`
    }, []);

    // Sunucu kasa seçilmemişse HİÇBİR satır döndürmez (CashViewFilter: kasa yoksa id = -1).
    // Açılış filtresi yalnız "varsayılan" işaretli kasayı kullanıyordu; hiçbir kasası varsayılan
    // olmayan kullanıcıda ekran bomboş açılıyor, üstelik kasa kutusu (CashRegisterSelectList'in
    // onList'i) kullanıcının TÜM kasalarını seçili gösterdiği için ekran kendi kendini yalanlıyordu.
    // Açılış sorgusu da o listeyle yapılır: görünen filtre ile listelenen veri aynı olur.
    const cashRegisterIdList = user?.userCashRegisters?.map(x => x.cashRegisterId) ?? [];

    return (
        <SimpleLayout fullWidth={true}>
            <DataGridProvider
                defaultFilter={{
                    startDate: moment(),
                    endDate: moment(),
                    cashRegisterIdList
                }}
            >
                {/* Filtre randevu listesindeki gibi tablo kartının üstünde. */}
                <CashViewFilter />
                <Card title={t('Cash Register')}>
                    <CashViewGrid />
                </Card>
            </DataGridProvider>
        </SimpleLayout>
    )
}